import { useRef, useState } from 'react';
import { useSearchData } from '../../../../common-data/useSearchData';
import {
	IMenuItemEntry,
	IOtherWebsitesEntry,
} from '../../../../contentful/types/IMenuItem';
import { OTHER_WEBSITES_ID } from '../../../../features/app/pages/domain/constants/PageId';
import { useReciteMe } from '../../../../features/shared/recite-me/useReciteMe';
import { useClickOutside } from '../../../../hooks/useClickOutside';
import { useGetWebsiteDetails } from '../hooks/useSiteSectionDetails';
import {
	ListContainer,
	MobileNavListItem,
	NavContainer,
} from './Navigation.styles';
import NavItem from './NavItem';
import { NavButton } from './NavItem.styles';
import { SubMenu } from './SubMenu';

interface INavigationItemsProps {
	onClick?: (item: IMenuItemEntry | IOtherWebsitesEntry | undefined) => void;
}

export function NavigationItems({ onClick }: INavigationItemsProps) {
	const { menuItems, currentSiteSectionId, siteSections } =
		useGetWebsiteDetails();
	const { isSearchOpen, updateSearchOpen } = useSearchData();

	const reciteMe = useReciteMe();

	const [selectedItem, setSelectedItem] = useState<
		IMenuItemEntry | IOtherWebsitesEntry
	>();
	const subNavRef = useRef<HTMLUListElement>(null);
	const isOpen = !!selectedItem;
	useClickOutside(subNavRef, () => {
		handleItemClick(undefined);
	});

	const otherWebsitesItem: IOtherWebsitesEntry = {
		id: OTHER_WEBSITES_ID,
		fields: {
			title: 'Our Sites',
			page: undefined,
			subMenuItems: siteSections.filter(
				(item) => item.fields.id !== currentSiteSectionId,
			),
		},
	};

	const handleItemClick = (
		item: IMenuItemEntry | IOtherWebsitesEntry | undefined,
	) => {
		setSelectedItem(selectedItem?.id === item?.id ? undefined : item);
		if (onClick) onClick(item);
	};

	return (
		<NavContainer isSubmenuOpen={isOpen} aria-label="main-navigation">
			<ListContainer ref={subNavRef}>
				{menuItems.map((item: IMenuItemEntry) => (
					<NavItem
						key={item.id}
						item={item}
						isSubmenuOpen={isOpen}
						siteSectionId={currentSiteSectionId}
						isActive={selectedItem?.id === item.id}
						onClick={handleItemClick}
					/>
				))}
				{!!otherWebsitesItem.fields.subMenuItems.length && (
					<NavItem
						item={otherWebsitesItem}
						isSubmenuOpen={isOpen}
						siteSectionId={currentSiteSectionId}
						isActive={selectedItem?.id === otherWebsitesItem.id}
						onClick={handleItemClick}
					/>
				)}
				<MobileNavListItem
					isActive={false}
					open={isOpen}
					className="no-max-width"
				>
					<NavButton
						isActive={false}
						isSubmenuOpen={isOpen}
						onClick={reciteMe.openToolbar}
					>
						Accessibility
					</NavButton>
				</MobileNavListItem>
				<SubMenu
					parentItem={selectedItem}
					onClick={() => {
						if (isSearchOpen) updateSearchOpen(false);
					}}
					open={isOpen}
				/>
			</ListContainer>
		</NavContainer>
	);
}
